import router from 'router'

export default class PopinManager {
    constructor() {

    }

    next(currentKey){
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(router.resolve({ name: 'popin.next', params: { index: currentKey } }).href, {},
                (response) => {
                    resolve(response)
                },
                (error) => {
                    reject(error)
                }
            );

        })
    }

    process(response) {
        switch(response.type){
            case 'none':
                return false
                break;
        }
    }
}